var _path, _rect, _rect2, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGasDayIconInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#A3BAC6",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#A3BAC6",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 19.5L10.7848 20.3739L11.0001 19.5ZM10.0001 5L10.8733 4.78169L10.3798 2.80795L9.25129 4.5008L10.0001 5ZM11.5 11.5L10.6462 11.7846L11.2932 13.7254L12.2867 11.9371L11.5 11.5ZM14.0001 7L14.7201 6.46L13.8874 5.34973L13.2134 6.5629L14.0001 7ZM17.0002 17.5L17.7401 18.0123L17.0002 17.5ZM11.2154 18.6261C9.4417 18.1891 8.54454 17.4339 8.05652 16.6153C7.54636 15.7596 7.4 14.6995 7.4 13.5H5.6C5.6 14.8005 5.74826 16.2586 6.51044 17.5371C7.29476 18.8526 8.64764 19.8473 10.7848 20.3739L11.2154 18.6261ZM7.4 13.5C7.4 11.9041 7.95916 10.2998 8.67886 8.87123C9.39778 7.44425 10.2322 6.27442 10.749 5.4992L9.25129 4.5008C8.76813 5.22558 7.85252 6.51081 7.07135 8.06136C6.29095 9.61036 5.6 11.506 5.6 13.5H7.4ZM9.12703 5.21831C9.37166 6.19667 9.61608 7.41944 9.86938 8.62287C10.1169 9.79899 10.3769 10.9767 10.6462 11.7846L12.3538 11.2154C12.1231 10.5233 11.8831 9.45101 11.6308 8.25213C11.3842 7.08056 11.1287 5.80333 10.8733 4.78169L9.12703 5.21831ZM12.2867 11.9371L14.7869 7.4371L13.2134 6.5629L10.7133 11.0629L12.2867 11.9371ZM13.2801 7.54C13.7964 8.22838 15.5322 10.5765 16.1952 11.9025L17.8051 11.0975C17.0539 9.59502 15.2039 7.10495 14.7201 6.46L13.2801 7.54ZM16.1952 11.9025C17.1247 13.7616 17.3264 15.4476 16.2602 16.9877L17.7401 18.0123C19.3414 15.6993 18.8756 13.2384 17.8051 11.0975L16.1952 11.9025ZM16.2602 16.9877C15.1137 18.6437 13.3381 19.1491 11.2154 18.6261L10.7848 20.3739C13.4584 21.0326 16.0748 20.4178 17.7401 18.0123L16.2602 16.9877Z",
    fill: "#C6D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5H20V-1.5H4V1.5ZM22.5 4V20H25.5V4H22.5ZM20 22.5H4V25.5H20V22.5ZM1.5 20V4H-1.5V20H1.5ZM4 22.5C2.61929 22.5 1.5 21.3807 1.5 20H-1.5C-1.5 23.0376 0.962435 25.5 4 25.5V22.5ZM22.5 20C22.5 21.3807 21.3807 22.5 20 22.5V25.5C23.0376 25.5 25.5 23.0376 25.5 20H22.5ZM20 1.5C21.3807 1.5 22.5 2.61929 22.5 4H25.5C25.5 0.962434 23.0376 -1.5 20 -1.5V1.5ZM4 -1.5C0.962434 -1.5 -1.5 0.962435 -1.5 4H1.5C1.5 2.61929 2.61929 1.5 4 1.5V-1.5Z",
    fill: "#A3BAC6",
    fillOpacity: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasDayIconInactive);
export default __webpack_public_path__ + "static/media/gasDayIconInactive.09f7060e7ef726e6e3ffe9cac0660a42.svg";
export { ForwardRef as ReactComponent };